import Vuex from 'vuex'
import Vue from 'vue'
import user from './modules/user'
import ui from './modules/ui'


Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user,
        ui
    }
})